import React from 'react';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../style/main.scss';
import SideBarButton from '../components/SideBarButton/SideBarButton';
import TopHeader from '../components/TopHeader/TopHeader';
import ProjectInfo from '../components/ProjectInfo';
import Pdf from '../files/TNM095.pdf';

const repo = 'https://github.com/iriskotsinas/TDDD23_2D_game';

const item = {
  title: 'Free Your Mind - 2D platformer AI game',
  description:
    'A project made for the courses TDDD23 Design and Programming of Computer Games and TNM095 Artificial Intelligence for Interactive Media. Games and AI are becoming more and more integrated to give the user a better experience and make games more fun to play. The aim of this project was to make a 2D platformer game, where the player has access to an artificially intelligent book that can classify doodle drawings using a trained neural network. This is a game that challenges your creativity and gives you a freedom to play the game however you want to play it and solve problems however you want to solve it. The project started with an attempt to build our own convolutional neural network that uses the ”Quick, Draw!" dataset.',
  description2:
    'Due to lack of access to powerful GPU/TPUs to train the large dataset, the number of classes was reduced to 50 instead of 345 and only contained animals. However, the final game uses a pre-trained model called DoodleNet to ensure fun and high quality gameplay. There are three ways to play this game: Draw your way through it (draw items and spawn as objects), say the object\'s name or write the object\'s name. Since we say "A picture is worth a thousand words", we made drawn objects more powerful. For weapons, they deal more damage, for vehicles they are faster and so on.',
  image: '',
  image2: '',
  slug: '/freeyourmind',
  report: Pdf,
  simulation: '',
  sourcecode: repo,
  video: 'https://www.youtube.com/watch?v=sAoJyfAJC10&t=3s',
};

export default function FreeYourMind() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Iris Kotsinas</title>
        <html lang="en" />
        <meta name="description" content="Iris Portfolio" />
      </Helmet>
      <TopHeader isStartPage={false} />
      <ProjectInfo item={item} isSpecial={false} />
      <SideBarButton showBelow={70} />
    </>
  );
}
